'use client';

import classNames from 'classnames';
import { HTMLAttributes } from 'react';

interface SectionErrorProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  alertClassName?: string;
  error?: string;
}

const SectionError = ({
  className,
  alertClassName,
  error,
  ...rest
}: SectionErrorProps) => {
  if (!error) return null;
  return (
    <div className={classNames('px-1 py-2', className)} {...rest}>
      <div
        role="alert"
        className={classNames(
          'alert border-error rounded-lg border-dashed bg-transparent p-3 hover:border-solid',
          alertClassName
        )}>
        <span className="text-sm">{error}</span>
      </div>
    </div>
  );
};

export default SectionError;
